import { ASSETCHAIN, ASSETCHAIN_TESTNET } from "./chains";

const BACKEND_BASE_URL = import.meta.env.VITE_BACKEND_URL;
const BRIDGE_BASE_URL = import.meta.env.VITE_BRIDGE_URL;

export const BACKEND_URLS = {
  default: `${BACKEND_BASE_URL}/`,
  rest: `${BACKEND_BASE_URL}/`,
  [ASSETCHAIN]: `${BACKEND_BASE_URL}/`,
  [ASSETCHAIN_TESTNET]: `${BACKEND_BASE_URL}/`,
  bridge: `${BRIDGE_BASE_URL}/`,
};

export function getServerBaseUrl(chainId: number) {
  if (!chainId) {
    throw new Error("chainId is not provided");
  }

  if (document.location.hostname.includes("deploy-preview")) {
    const fromLocalStorage = localStorage.getItem("SERVER_BASE_URL");
    if (fromLocalStorage) {
      return fromLocalStorage;
    }
  }

  return BACKEND_URLS[chainId] || BACKEND_URLS.default;
}

export function getServerUrl(chainId: number, path: string) {
  const baseUrl = getServerBaseUrl(chainId);
  const normalizedPath = path.startsWith("/") ? path.slice(1) : path;
  return `${baseUrl}${normalizedPath}`;
}
